export default __webpack_public_path__ + "icon_success52268d.svg";